import { render, staticRenderFns } from "./OfflineMeetingHistoryDetail.vue?vue&type=template&id=5b083dc7&"
import script from "./OfflineMeetingHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./OfflineMeetingHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports